interface SelectCategoryProps {
  selectedCategory: DefaultCategories;
  setSelectedCategory: (value: DefaultCategories) => void;
}

function SelectCategory({
  selectedCategory,
  setSelectedCategory,
}: SelectCategoryProps) {
  const categories: Array<DefaultCategories> = ['Precious Metals', 'Base Metals', 'Energy', 'Cryptos', 'All'];
  return (
    <div>
      <select
        value={selectedCategory}
        onChange={(e) => {
            setSelectedCategory(e.target.value as DefaultCategories);
        }}
        className='mr-2 lg:mr-2 p-1 text-[14px] rounded border bg-white dark:bg-gray-700 text-gray-900 dark:text-white h-[32px]'
      >
        {categories.map((category) => (
          <option key={category} value={category}>
            {category}
          </option>
        ))}
      </select>
    </div>
  );
}

export default SelectCategory;